import { compose } from 'redux';

import type { TrackingState } from '../../trackingStore';

export const selectTrackingDomain = (state: TrackingState) => state.tracking;

export const selectDrivers = compose((state) => state.driversWebData, selectTrackingDomain);

export const selectDevice = compose((state) => state.deviceWebData, selectTrackingDomain);

export const selectDevicesVehicles = compose((state) => state.devicesVehiclesWebData, selectTrackingDomain);

export const selectPathGeojson = compose((state) => state.pathGeojsonWebData, selectTrackingDomain);

export const selectRoadSpeedEvents = compose((state) => state.roadSpeedEventsWebData, selectTrackingDomain);

export const selectVehicleSpeedEvents = compose((state) => state.vehicleSpeedEventsWebData, selectTrackingDomain);

export const selectStops = compose((state) => state.stopWebData, selectTrackingDomain);

export const selectSummary = compose((state) => state.summaryWebData, selectTrackingDomain);

export const selectIncidentsWebData = compose((state) => state.incidentsWebData, selectTrackingDomain);

export const selectVehicle = compose((state) => state.vehicleWebData, selectTrackingDomain);

export const selectSelectedDate = compose((state) => state.selectedDate, selectTrackingDomain);

export const selectSelectedSavedRoute = compose((state) => state.selectedSavedRoute, selectTrackingDomain);

export const selectSelectedTrigger = compose((state) => state.selectedTrigger, selectTrackingDomain);

export const selectSelectedGeofence = compose((state) => state.selectedGeofenceId, selectTrackingDomain);
